/**
 * Block Number Mapping — Single Source of Truth (Web)
 * Ported verbatim from mobile/src/utils/blockMapping.ts.
 * The same mapping logic exists in /app/backend/block_mapping.py.
 */

const TYPE_A = [
  { block: "A-1", ranges: [[1, 11], [37, 46]] },
  { block: "A-2", ranges: [[12, 36]] },
];

const TYPE_B = [
  { block: "B-1", ranges: [[1, 16]] },
  { block: "B-2", ranges: [[17, 38]] },
  { block: "B-3", ranges: [[39, 60]], specials: ["41Z", "51Z"] },
  { block: "B-4", ranges: [[61, 78]], specials: ["67Z", "71Z"] },
  { block: "B-5", ranges: [[79, 104]] },
  { block: "B-6", ranges: [[105, 130]] },
  { block: "B-7", ranges: [[131, 137], [161, 167]] },
  { block: "B-8", ranges: [[138, 160]] },
  { block: "B-9", ranges: [[168, 179], [206, 217]] },
  { block: "B-10", ranges: [[180, 205]] },
  { block: "B-11", ranges: [[218, 227], [250, 259]] },
  { block: "B-12", ranges: [[228, 249]] },
  { block: "B-13", ranges: [[260, 271], [298, 309]] },
  { block: "B-14", ranges: [[272, 297]] },
  { block: "B-15", ranges: [[310, 321]] },
  { block: "B-16", ranges: [[322, 335]] },
  { block: "B-17", ranges: [], specials: ["1Z", "2Z", "3Z", "4Z"] },
  { block: "B-18", ranges: [[336, 341]] },
  { block: "B-19", ranges: [[342, 365]] },
  { block: "B-20", ranges: [[366, 381]] },
  { block: "B-21", ranges: [[382, 397]] },
  { block: "B-22", ranges: [[398, 421]] },
  { block: "B-23", ranges: [[422, 443]] },
  { block: "B-25", ranges: [[444, 450]] },
  { block: "B-24", ranges: [[451, 464]] },
  { block: "B-26", ranges: [[465, 486]] },
  { block: "B-27", ranges: [[487, 492]] },
  { block: "B-28", ranges: [[493, 514]] },
  { block: "B-29", ranges: [[515, 538]] },
];

const TYPE_C = [
  { block: "C-1", ranges: [[2, 36]] },
  { block: "C-2", ranges: [[37, 64]] },
  { block: "C-3", ranges: [[65, 94]] },
];

const BLOCK_MAP = { A: TYPE_A, B: TYPE_B, C: TYPE_C };

function normalize(houseNum) {
  return houseNum.trim().replace(/\s+/g, "").toUpperCase();
}

function parseHouse(raw) {
  const normalized = normalize(raw);
  if (!normalized) return null;
  const match = normalized.match(/^(\d+)([A-Z]*)$/);
  if (!match) return null;
  return { num: parseInt(match[1], 10), suffix: match[2], normalized };
}

export function getBlockNumber(homeType, houseNumber) {
  if (!homeType || !houseNumber) return null;
  const type = homeType.trim().toUpperCase();
  const blocks = BLOCK_MAP[type];
  if (!blocks) return null;
  const parsed = parseHouse(houseNumber);
  if (!parsed) return null;

  if (parsed.suffix) {
    for (const def of blocks) {
      if (def.specials?.includes(parsed.normalized)) return def.block;
    }
    return null;
  }
  for (const def of blocks) {
    for (const [lo, hi] of def.ranges) {
      if (parsed.num >= lo && parsed.num <= hi) return def.block;
    }
  }
  return null;
}

export function isValidHouse(homeType, houseNumber) {
  return getBlockNumber(homeType, houseNumber) !== null;
}

export function getHomeTypes() {
  return Object.keys(BLOCK_MAP);
}
